import React from "react";
import { Snackbar, Alert, SnackbarProps, AlertProps } from "@mui/material";

interface KenSnackbarProps extends SnackbarProps {
    message: string;
    open: boolean;
    onClose: () => void;
    severity?: AlertProps["severity"];
}

const KenSnackbar: React.FC<KenSnackbarProps> = ({
    message,
    open,
    onClose,
    severity = "success",
    ...snackbarProps
}) => {
    return (
        <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            {...snackbarProps}
        >
            <Alert
                onClose={onClose}
                severity={severity}
                sx={{
                    bgcolor: "white",
                    color: "black",
                    borderBottom: "4px solid green",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                }}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};

export default KenSnackbar;